import React, { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import IdentificationPage from './pages/IdentificationPage';
import QuestionnairePage from './pages/QuestionnairePage';
import ResultsPage from './pages/ResultsPage';
import HistoryPage from './pages/HistoryPage';
import ExplicationsPage from './pages/ExplicationsPage';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [currentAssessment, setCurrentAssessment] = useState(null);

  return (
    <div className="App min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={
              <IdentificationPage 
                setCurrentUser={setCurrentUser} 
              />
            } 
          />
          <Route 
            path="/questionnaire" 
            element={
              currentUser ? (
                <QuestionnairePage 
                  user={currentUser} 
                  setCurrentAssessment={setCurrentAssessment}
                />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/results" 
            element={
              currentAssessment ? (
                <ResultsPage 
                  assessment={currentAssessment}
                  user={currentUser}
                />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/history" 
            element={
              currentUser ? (
                <HistoryPage 
                  user={currentUser}
                  setCurrentAssessment={setCurrentAssessment}
                />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/explications" 
            element={<ExplicationsPage />} 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
